/**
 * Premières publications hors articles d'analyse :
 *   - Guides : documents pratiques d'orientation (5-15 min de lecture)
 *   - Fiches pratiques : repères opérationnels courts (2-5 min)
 *
 * Pour l'instant, ces ressources s'affichent sur /ressources sans page
 * détail dédiée. Elles seront publiées progressivement.
 */

export const GUIDES = [
    {
        slug: "guide-rh-accessibilite-cognitive",
        category: "Guide",
        date: "Mai 2026",
        readTime: "12 min",
        title:
            "Mettre en place une démarche d'accessibilité cognitive en entreprise",
        excerpt:
            "Un guide à destination des services RH et des managers : poser un cadre, identifier les obstacles cognitifs invisibles, organiser l'usage des outils numériques sans stigmatiser. Démarche en quatre étapes.",
    },
];

export const FICHES = [
    {
        slug: "fiche-reformuler-une-consigne",
        category: "Fiche pratique",
        date: "Mai 2026",
        readTime: "3 min",
        title: "Reformuler une consigne avec un outil d'IA",
        excerpt:
            "Méthode courte pour transformer une consigne ambiguë en une suite d'étapes claires, sans dénaturer le sens d'origine. Trois prompts éprouvés, deux écueils à éviter.",
    },
    {
        slug: "fiche-simplifier-courrier-administratif",
        category: "Fiche pratique",
        date: "Mai 2026",
        readTime: "4 min",
        title: "Simplifier un courrier administratif",
        excerpt:
            "Décoder un courrier dense, isoler la demande, préparer une réponse cohérente. Repères pour ne pas se laisser intimider par le jargon administratif.",
    },
];
